// Web-only guard for stale-deploy chunk failures: after a redeploy, the browser
// can hold an old page whose lazy chunks no longer exist. The server answers
// the missing chunk with the SPA index.html, which fails to parse as JS
// ("Unexpected token '<'", "Requiring unknown module", dynamic import
// failures). Reloading once picks up the fresh deploy. The sessionStorage flag
// prevents reload loops. See CHURCH-APP-12J / CHURCH-APP-12H.
const CHUNK_LOAD_PATTERNS = [
    "Unexpected token '<'",
    'Requiring unknown module',
    'dynamically imported module',
    'Importing a module script failed',
    'Loading chunk',
];

const RELOAD_FLAG_KEY = 'chunkReloadAttempted';

const isChunkLoadError = (message) => typeof message === 'string' && CHUNK_LOAD_PATTERNS.some((pattern) => message.includes(pattern));

const reloadOnce = () => {
    try {
        if (sessionStorage.getItem(RELOAD_FLAG_KEY)) return;
        sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
    } catch { /* sessionStorage unavailable — don't reload, avoid a loop */ }
    window.location.reload();
};

const installChunkReloadGuard = () => {
    window.addEventListener('error', (event) => {
        if (isChunkLoadError(event?.message)) reloadOnce();
    });
    window.addEventListener('unhandledrejection', (event) => {
        if (isChunkLoadError(event?.reason?.message || event?.reason)) reloadOnce();
    });
};

export default installChunkReloadGuard;
